import React from 'react'
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet'
import L from 'leaflet'

// Pour éviter une erreur d'icône manquante, ajoute ce bloc
delete L.Icon.Default.prototype._getIconUrl
L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})

const MapView = ({ lat, lon }) => {
    const position = [lat, lon] // Définit la position selon les props

    return (
        <MapContainer
            center={position}
            zoom={13}
            style={{ height: '400px', width: '100%', borderRadius: '20px' }}
        >
            {/* TileLayer pour charger la carte d'OpenStreetMap */}
            <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            />

            {/* Ajouter un marqueur à la position définie */}
            <Marker position={position}>
                <Popup>
                    Location: [{lat}, {lon}]
                </Popup>
            </Marker>
        </MapContainer>
    )
}

export default MapView
